// extracted by mini-css-extract-plugin
export default {"disable-product":"Product_disable-product__puUyO","disable-product-message":"Product_disable-product-message__Z8Pz3"};